var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLessonsBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 281.41 268.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#48b2d2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.7,0C63.12,0,0,60.13,0,134.05s63.12,134.05,140.7,134.05,140.71-60.13,140.71-134.05S218.29,0,140.7,0Zm0,220.77c-50.2,0-91.03-38.91-91.03-86.73S90.51,47.32,140.7,47.32s91.04,38.91,91.04,86.73-40.84,86.73-91.04,86.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.35,
    cy: 150.2,
    r: 11.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.35,
    cy: 183.45,
    r: 11.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.35,
    cy: 116.95,
    r: 11.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.35,
    cy: 83.71,
    r: 11.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 140.16,
    cy: 135.54,
    r: 11.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 140.16,
    cy: 168.79,
    r: 11.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 140.16,
    cy: 102.3,
    r: 11.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 166.41,
    cy: 152.03,
    r: 11.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 166.41,
    cy: 118.78,
    r: 11.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 191.79,
    cy: 135.8,
    r: 11.08
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonsBlue);
export default __webpack_public_path__ + "static/media/LessonsBlue.6d299dbb61833da5b7e00738a4ce8004.svg";
export { ForwardRef as ReactComponent };